import { action } from 'satcheljs';
/**
 * Action to update the calendar processing options in store
 */
export var updateCalendarProcessingOptions = action('updateCalendarProcessingOptions', function (calendarProcessingOptions) { return ({
    calendarProcessingOptions: calendarProcessingOptions,
}); });
export default updateCalendarProcessingOptions;
//# sourceMappingURL=updateCalendarProcessingOptions.js.map